import type { GroupBase, MultiValue, PropsValue, SingleValue, StylesConfig } from 'react-select';
import Select from 'react-select';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SelectOption = Record<string, string | boolean | number>;

export type FilterSelectAutocompleteProps = {
  id: string;
  placeholder: string;
  isMulti?: boolean;
  label?: string;
  value: PropsValue<SelectOption>;
  onChange: (value: string | string[]) => void;
  options: SelectOption[];
  filterOptions?: (
    option: {
      label: string;
      value: string;
    },
    inputValue: string
  ) => boolean | null;
  styles?: StylesConfig<SelectOption, boolean, GroupBase<SelectOption>>;
  isClearable?: boolean;
  hideOptionsModel?: boolean;
};

export const FilterSelectAutocomplete = ({
  id,
  placeholder,
  isMulti = false,
  label,
  value,
  onChange,
  options,
  filterOptions,
  styles = {},
  isClearable = true,
  hideOptionsModel = false,
}: FilterSelectAutocompleteProps) => (
  <>
    {label && (
      <label htmlFor={`${id}_input`} className="block mb-4">
        {label}
      </label>
    )}
    <Select
      id={id}
      // eslint-disable-next-line react/no-unstable-nested-components
      formatOptionLabel={option => (
        <div className="flex justify-between">
          <div className="min-w-0 flex-1 mr-1">
            <span className="block truncate">{option.label}</span>
          </div>
          {!hideOptionsModel && <div className="flex-shrink-0 text-right">({option.models})</div>}
        </div>
      )}
      isMulti={isMulti}
      inputId={`${id}_input`}
      data-testid={id}
      placeholder={placeholder}
      instanceId={`${id}_instance`}
      value={value}
      onChange={a => {
        if (isMulti) {
          onChange((a as MultiValue<SelectOption>)?.map(item => item.value as string) || []);
        } else {
          onChange(((a as SingleValue<SelectOption>)?.value as string) || '');
        }
      }}
      isClearable={isClearable}
      options={options}
      filterOption={filterOptions}
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#2C74A9',
        },
      })}
      styles={{
        ...styles,
        container: base => ({
          ...base,
          marginBottom: '1.5rem',
          fontSize: '1.4rem',
          ...styles?.container,
        }),
        menu: base => ({
          ...base,
          minWidth: '100%',
          width: 'auto',
          height: 'auto',
          ...styles?.menu,
        }),
        multiValue: (base, props) => ({
          ...base,
          ...(styles?.multiValue ? styles?.multiValue(base, props) : {}),
        }),
        multiValueLabel: (base, props) => ({
          ...base,
          ...(styles?.multiValueLabel ? styles?.multiValueLabel(base, props) : {}),
        }),
        option: (base, props) => ({
          ...base,
          width: 'auto',
          maxWidth: '80vw',
          height: 'auto',
          fontSize: '1.4rem',
          ...(styles?.option ? styles?.option(base, props) : {}),
        }),
      }}
    />
  </>
);
